(function () {
    'use strict';

    angular
        .module('skillsApp')
        .factory('notifyingService', notifyingService);
    
    function notifyingService($rootScope) {
        return {
            subscribe: function (scope, eventName, callback) {
                var handler = $rootScope.$on(eventName, callback);
                scope.$on('$destroy', handler);
            },

            notify: function (eventName, params) {
                $rootScope.$emit(eventName, params);
            }
        };
    }

})();